// extracted by mini-css-extract-plugin
export default {"footer":"DisclaimerFooter_footer__1riGz","list":"DisclaimerFooter_list__JjcWt","item":"DisclaimerFooter_item__0phVK"};